import { useCallback } from 'react'

import { head, values } from 'lodash'
import Select from 'material/Select'

import { getSegmentOperation, getSegmentValue } from 'components/SegmentSelector/segment-service'
import ToggleableSection from 'components/ToggleableSection'

import { withContext } from '../Context'

export const SegmentName = 'IsKnown'

const OPERATIONS = {
  known: 'in',
} as const

export const OPTIONS: Record<string, {
  value: string
  label: string
  Operation: string
  Values: boolean[]
  getMatch?: (value: boolean[], operation: string) => boolean
}> = {
  all: {
    value: 'all',
    label: 'All Students',
    Operation: 'in',
    Values: [],
  },
  known: {
    value: 'known',
    label: 'In CRM',
    Operation: OPERATIONS.known,
    Values: [true],
    getMatch: (value, operation) => head(value) === true && operation === OPERATIONS.known,
  },
  unknown: {
    value: 'unknown',
    label: 'Not in CRM',
    Operation: OPERATIONS.known,
    Values: [false],
    getMatch: (value, operation) => head(value) === false && operation === OPERATIONS.known,
  },
}

export const getAppropriateOption = (value: boolean[], operation: string): string => {
  if (OPTIONS.known.getMatch?.(value, operation)) {
    return OPTIONS.known.value
  }
  if (OPTIONS.unknown.getMatch?.(value, operation)) {
    return OPTIONS.unknown.value
  }
  return OPTIONS.all.value
}

export const OPTIONS_ARRAY = values(OPTIONS)

interface KnownStudentSelectorProps {
  criteria?: string
  segment?: Record<string, unknown>
  onChange: (criteria: string, segmentName: string, values: boolean[], operation: string) => void
}

export const KnownStudentSelector = ({ criteria = 'Must', segment, onChange }: KnownStudentSelectorProps) => {
  const currentValue = getSegmentValue(segment, criteria, SegmentName)
  const currentOperation = getSegmentOperation(segment, criteria, SegmentName)
  const valueStr = getAppropriateOption(currentValue, currentOperation)
  const change = useCallback(
    (valueStr: string) => {
      const { Values, Operation } = OPTIONS[valueStr]
      onChange(criteria, SegmentName, Values, Operation)
    },
    [criteria, onChange],
  )
  return (
    <ToggleableSection
      title="CRM Status"
      info="Students known to your institution or not yet in your CRM"
    >
      <Select
        id="segmentation-known-student-selector"
        label="Student CRM Status"
        value={valueStr}
        // @ts-expect-error untyped Select component infers options as never[]
        options={OPTIONS_ARRAY}
        onChange={change}
      />
    </ToggleableSection>
  )
}

export default withContext(KnownStudentSelector)
